define.alias("shared/components/shared/expandable-truncated-text", "media/components/shared/expandable-truncated-text");